<template>
  <div>
    <div class="menu-main" v-if="$route.query.centrifugeType == 1">
        <div class="menu-bottom">
            <div class="left" @click="handleDetail('cenProgramme', 9, { centrifugeType: $route.query.centrifugeType })">
                <p class="txt">一站式离心方案</p>
                <p class="col">轻松应对不同应用场景</p>
                <img :src="cdnUrl + 'Fti18RFDmsgKzgQK5qzJLZ8BIhXG'">
            </div>
            <div class="right">
                <div class="menu-top-t" @click="handleDetail('filterProduct', '', { category_id: '106'})">
                    <div>
                        <p class="txt">台离产品一览</p>
                    </div>
                    <img :src="cdnUrl + 'tubular2.png'">
                </div>
                <div class="menu-top-t" @click="handleDetail('centrifuge', '', { type: '2'})">
                    <p class="txt">根据应用筛选离心机</p>
                    <img :src="cdnUrl + 'adhibition.png'">
                </div>
            </div>
        </div>
        <div class="menu-top" @click="handleDetail('operateGuide', 10, { centrifugeType: $route.query.centrifugeType })">
            <div class="left">
                <p class="txt">快速操作指南</p>
                <p class="col">视频文档快速解锁</p>
                <p class="line"></p>
            </div>
            <div>
                <img class="pro-img" :src="cdnUrl + 'fingerpost.png'">
            </div>
        </div>
        <div class="menu-top" @click="handleDetail('trove', 11)">
            <div class="left">
                <p class="txt">台离使用讲解及离心宝典</p>
                <p class="col">离心专家深度讲解</p>
                <p class="line"></p>
            </div>
            <div>
                <img class="pro-img" :src="cdnUrl + 'valuableBook.png'">
            </div>
        </div>
    </div>
    <div class="menu-main" v-else>
       <div class="top">
        <div class="box1" @click="handleDetail('filterProduct', 46, { category_id: '346'})">
          <div class="title">产品一览</div>
          <div class="txts">型号、参数及功能详情</div>
          <img class="img1" :src="cdnUrl+'eppendorf/product_bg.png'">
        </div>
        <div class="right_box">
          <div class="box2" @click="handleDetail('rotor', 47, {})">
            <div class="title">常用转子</div>
            <div class="txts">指南一应俱全备份</div>
            <img class="img2" :src="cdnUrl+'eppendorf/rotor_bg.png'">
          </div>
          <div class="box2" @click="handleDetail('expendables', 48, {})">
            <div class="title">耗材选型工具</div>
            <div class="txts">按实验条件轻松选</div>
            <img class="img2" :src="cdnUrl+'eppendorf/himac_bg.png'">
          </div>
        </div>
       </div>
       <div class="box3" @click="handleDetail('operateGuideCategory', 49, {})">
        <div class="info">
          <div class="title">操作维护指南</div>
          <div class="txts">指南一应俱全</div>
        </div>
        <img class="img3" :src="cdnUrl+'eppendorf/guide_bg.png'">
       </div>
       <div class="box3" @click="handleDetail('cenProgramme', 50, { centrifugeType: $route.query.centrifugeType })">
        <div class="info">
          <div class="title">应用文献</div>
          <div class="txts">样本离心应用</div>
        </div>
        <img class="img3" :src="cdnUrl+'eppendorf/literature_bg.png'">
       </div>
        <!-- <div class="menu-top" @click="handleDetail('filterProduct', '', { category_id: '346'})">
            <div class="left">
                <p class="txt">产品一览</p>
                <p class="col">型号、参数及功能详情</p>
                <p class="line"></p>
            </div>
            <div>
                <img class="pro-img" :src="cdnUrl + 'centrifugeProduct.png'">
            </div>
        </div>
        <div class="menu-top" @click="handleDetail('https://www.eppendorf.com/cn-zh/centrifuge-assistant/')">
            <div class="left">
                <p class="txt">快速选型</p>
                <p class="col">根据实验条件轻松筛选</p>
                <p class="line"></p>
            </div>
            <div>
                <img class="pro-img" :src="cdnUrl + 'modelSelection.png'">
            </div>
        </div>
        <div class="menu-top" @click="handleDetail('operateGuide', 10, { centrifugeType: $route.query.centrifugeType })">
            <div class="left">
                <p class="txt">操作维护指南</p>
                <p class="col">超/落离指南一应俱全</p>
                <p class="line"></p>
            </div>
            <div>
                <img class="pro-img" :src="cdnUrl + 'fingerpost.png'">
            </div>
        </div>
        <div class="menu-top" @click="handleDetail('cenProgramme', 37, { centrifugeType: $route.query.centrifugeType })">
            <div class="left">
                <p class="txt">应用案例</p>
                <p class="col">样本离心应用锦囊</p>
                <p class="line"></p>
            </div>
            <div>
                <img class="pro-img" :src="cdnUrl + 'case.png'">
            </div>
        </div> -->
    </div>
    <footerLine></footerLine>
  </div>
</template>

<script>
import { centrifugeRecord } from '@/libs/common'
import footerLine from '@/components/footerLine'
export default {
     components: {
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
        }
    },
    mounted() {
      document.title = this.$route.query.centrifugeType == 1 ? "台离知识库" : "超/落离知识库";
    },
    methods: {
        handleDetail(name, type, query = {}) {
            if (name.includes("http")) {
                window.location.href = name;
            } else {
                this.$router.push({ name, query });
            };
            let para = {
                type,
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            if (type) centrifugeRecord(para);
        }
    }
}
</script>

<style lang="scss" scoped>
.col {
  font-size: rem(12);
  padding: 0 rem(10) 0 0;
  color: #999999;
  margin-top: rem(4);
}
.txt {
  font-size: rem(14);
  color: #333333;
  font-weight: bold;
}
.menu-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  .menu-top {
    display: flex;
    justify-content: space-between;
    width: rem(345);
    height: rem(114);
    margin: 0 auto;
    margin-top: rem(15);
    background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
    border-radius: 4px;
    border: 1px solid rgba(103,195,216,0.3);
    .pro-img {
      margin: rem(8) rem(24) 0 0;
      width: rem(100);
      height: rem(100);
    }
    .left {
      position: relative;
      padding-left: rem(20);
    }
    .txt {
      margin-top: rem(30);
    }
    .line {
      position: absolute;
      bottom: rem(28);
      width: rem(126);
      height: rem(2);
      background: rgba(108,197,219,0.35);
      border-radius: 4px;
    }
  }
  .menu-bottom {
    display: flex;
    justify-content: center;
    margin-top: rem(15);
    .left {
      position: relative;
      width: rem(165);
      height: rem(215);
      padding: rem(12) 0 0 rem(12);
      margin-right: rem(15);
      background-image: url('https://cdn.juplus.cn/centrifugeBg.png');
      background-size: cover;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.07);
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid rgba(103,195,216,0.3);
      img {
        position: absolute;
        right: rem(8);
        bottom: 0;
        width: rem(88);
        height: rem(88);
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .menu-top-t {
        position: relative;
        width: rem(165);
        height: rem(100);
        padding: rem(12) 0 0 rem(12);
        background-image: url('https://cdn.juplus.cn/centrifugeBg2.png');
        background-size: cover;
        box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid rgba(103,195,216,0.3);
        img {
          position: absolute;
          right: rem(8);
          bottom: rem(2);
          width: rem(60);
          height: rem(60);
        }
      }
    }
  }
  .top{
    width: rem(343);
    display: flex;
    justify-content: space-between;
    margin-top: rem(17);
    .box1{
      width: rem(163);
      height: rem(235);
      background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
      box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
      border-radius: 6px;
      border: 1px solid rgba(89,193,214,0.3);
      padding: rem(18) rem(16);
      box-sizing: border-box;
      position: relative;
      .title{
        //  font-weight: bold;
          font-size: rem(14);
          color: #333333;
          line-height: rem(20);
      }
      .txts{
        font-size: rem(12);
        color: #999999;
        line-height: rem(17);
        margin-top: rem(2);
      }
      .img1{
        width: rem(68);
        height: rem(74);
        position: absolute;
        right: rem(14);
        bottom: rem(12);
      }
    }
    .right_box{
      width: rem(165);
      height: rem(235);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .box2{
        width: rem(165);
        height: rem(110);
        background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
        box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
        border-radius: 4px;
        border: 1px solid rgba(89,193,214,0.3);
        padding: rem(18) rem(12);
        box-sizing: border-box;
        position: relative;
        .title{
          // font-weight: bold;
            font-size: rem(14);
            color: #333333;
            line-height: rem(20);
        }
        .txts{
          font-size: rem(12);
          color: #999999;
          line-height: rem(17);
          margin-top: rem(2);
        }
        .img2{
          width: rem(52);
          height: rem(52);
          position: absolute;
          right: rem(7);
          bottom: rem(9);
        }
      }
    }
  }
  .box3{
    width: rem(343);
    height: rem(104);
    margin-top: rem(16);
    background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
    border-radius: 4px;
    border: 1px solid rgba(89,193,214,0.3);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info{
      margin-left: rem(21);
      .title{
        // font-weight: bold;
          font-size: rem(14);
          color: #333333;
          line-height: rem(20);
      }
      .txts{
        font-size: rem(12);
        color: #999999;
        line-height: rem(17);
        margin-top: rem(4);
      }
    }
    .img3{
       width: rem(71);
       height: rem(71);
       margin-right: rem(28);
    }
  }
}
</style>